import { Navigate } from "react-router";

/** Legacy URL: reindirizza al Control Hub e apre il pannello Ask Eve */
export const ShipperAskEvePage = () => (
    <Navigate to="/shipper/control-hub" replace state={{ openAskEve: true }} />
);
